/* 
 	* 车辆报警详情组件 
 	* 描述：具体报警内容部分
 	* 创建时间：2017-05-04 
 	* 创建人：baixx 
*/
<template>
	<div class="ibox float-e-margins ibox-content" style="position: relative; height: 100%;">
		<!--表单查询开始-->
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">报警类型</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="detailInfo.almTypeName" readonly>
				</div>
				<label class="col-sm-1 control-label">紧急度</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="detailInfo.almLevelName" readonly>
				</div>
				<label class="col-sm-1 control-label">报警时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="detailInfo.almTime" readonly>
				</div>
			</div>
			<div class="form-group">
		        <label class="col-sm-1 text-right control-label">报警内容</label>
		        <div class="col-sm-11">
			        <textarea class="form-control" rows="5" v-model="detailInfo.almMessage" readonly></textarea>
			    </div>
			</div>
		    <div class="form-group">
		        <label class="col-sm-1 text-right control-label">报警地点</label>
		        <div class="col-sm-11">
			        <textarea class="form-control" rows="5" v-model="detailInfo.address" readonly></textarea>
			    </div>
		    </div>
		    <div class="form-group">
				<label class="col-sm-1 control-label">处理人</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="detailInfo.handleName" readonly>
				</div>
				<label class="col-sm-1 control-label">处理时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="detailInfo.handleTime" readonly>
				</div>
				<label class="col-sm-1 control-label">处理状态</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="detailInfo.handleStatusName" readonly>
				</div>
			</div>
			<div class="form-group">
		        <label class="col-sm-1 text-right control-label">处理结果</label>
		        <div class="col-sm-11">
			        <textarea class="form-control" rows="5" v-model="detailInfo.handleResult" readonly></textarea>
			    </div>
		   </div>
			<!--<div class="form-group">
				<div class="col-sm-12 text-center">
					<button class="btn btn-primary" @click="alarmScene">查看报警现场</button>
				</div>
			</div>-->
		</div>
		<!--表单查询结束-->			
	</div>
</template>
<script>
	export default {
		name: "vehicleAlarmDetails",
		props: ["detailInfo"],
		methods: {
			//查看报警现场
//			alarmScene(msgId,vId){   
//				//1，进入轨迹回放tab
//				const obj = {
//					name:'车辆轨迹回放',
//					code:'vehicleTrace',
//					id:'PageVehicleTrace',
//					route:'/indexhome/vehicleTrace',
//					No:'vehicleTrace'
//				}
//				this.addTab(obj)
//				//2,追加报警现场队列
//				const param = {
//					almMsgId:msgId,
//					vehicleId:vId
//				}
//				this.$store.dispatch('addAlarmLive',param)
//
//			}
		}
	}
</script>



// WEBPACK FOOTER //
// vehicleAlarmDetails.vue?157e96de